import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { deleteInvoice } from '../query-api'

interface UseDeleteInvoiceProps {
  onError?: (error?: APIError) => void
  onSuccess?: (data: void) => void
}

export const useDeleteInvoice = (props?: UseDeleteInvoiceProps) => {
  const { onError, onSuccess } = props || {}

  const { mutate, isLoading, ...rest } = useMutation(deleteInvoice, {
    onSuccess,
    onError,
  })

  return { deleteInvoice: mutate, isProcessing: isLoading, ...rest }
}
